export default __webpack_public_path__ + "static/media/youtube.43467933.svg";